import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog"
import { cn } from "@/lib/utils"
import { cva } from "class-variance-authority"

interface ModalProps {
  title?: string
  children: React.ReactNode
  open?: boolean
  onOpenChange?: (open: boolean) => void
  trigger?: React.ReactNode
  size?:  "xs" | "sm" | "md" | "lg" | "xl" | "default"
  contentClassName?: string
  headerClassName?: string
}

const modalVariants = cva("", {
  variants: {
    // variant: {
    //   default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90 disabled:bg-primary/20 disabled:text-foreground",
    //   destructive:
    //     "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
    //   outline: "border border-input bg-background shadow-xs hover:bg-accent hover:text-accent-foreground",
    //   secondary: "bg-accent text-accent-foreground shadow-xs hover:bg-accent/80",
    //   ghost: "hover:bg-accent hover:text-accent-foreground",
    //   link: "text-primary underline-offset-4 hover:underline",
    //   shadow: "bg-background shadow-button hover:bg-background/50",
    // },
    size: {
      default: "",
      sm: "md:max-w-md",
      xl: "md:max-w-3xl",
    },
  },
  defaultVariants: {
    // variant: "default",
    size: "default",
  },
})

function Modal(props: ModalProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      {props.trigger && <DialogTrigger asChild>{props.trigger}</DialogTrigger>}
      <DialogContent className={cn(modalVariants({ size: props.size }), props.contentClassName)}>
        {/* <DialogHeader className="min-h-10 px-6 pt-5 pb-2"> */}
        <DialogHeader className={cn(props.headerClassName)}>
          <DialogTitle className="text-xl font-bold">{props.title}</DialogTitle>
          <DialogDescription />
        </DialogHeader>
        <div className="flex max-h-[500px]">{props.children}</div>
      </DialogContent>
    </Dialog>
  )
}

export default Modal
